import React from "react";
import {
  createStyles,
  Header,
  Group,
  Text,
  Divider,
  Box,
  Burger,
  Drawer,
  ScrollArea,
  rem,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";

const useStyles = createStyles((theme) => ({
  link: {
    display: "flex",
    alignItems: "center",
    height: "100%",
    paddingLeft: theme.spacing.md,
    paddingRight: theme.spacing.md,
    textDecoration: "none",
    color: "#9b9974",
    fontSize: theme.fontSizes.md,

    [theme.fn.smallerThan("sm")]: {
      height: rem(42),
      display: "flex",
      alignItems: "center",
      color: "#9b9974",

      width: "100%",
    },
  },

  subLink: {
    width: "100%",
    padding: `${theme.spacing.xs} ${theme.spacing.md}`,
    borderRadius: theme.radius.md,

    "&:active": theme.activeStyles,
  },

  dropdownFooter: {
    backgroundColor:
      theme.colorScheme === "dark"
        ? theme.colors.dark[7]
        : theme.colors.gray[0],
    margin: `calc(${theme.spacing.md} * -1)`,
    marginTop: theme.spacing.sm,
    padding: `${theme.spacing.md} calc(${theme.spacing.md} * 2)`,
    paddingBottom: theme.spacing.xl,
    borderTop: `${rem(1)} solid ${
      theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[1]
    }`,
  },

  header: {
    borderBottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  hiddenMobile: {
    [theme.fn.smallerThan("sm")]: {
      display: "none",
    },
  },

  hiddenDesktop: {
    [theme.fn.largerThan("sm")]: {
      display: "none",
    },
  },

  // a:hover {
  //   color: rgb(141, 107, 85);
  // }

  // a {
  //   color: #9b9974;
  // }

  titlelink: {
    color: "#e27130",
    display: "flex",
    alignItems: "center",
    fontFamily: "Nanum Myeongjo, serif",
    height: "100%",
    paddingLeft: theme.spacing.md,
    paddingRight: theme.spacing.md,
    textDecoration: "none",
    fontSize: rem(45),

    [theme.fn.smallerThan("sm")]: {
      color: "#e27130",
      height: rem(42),
      display: "flex",
      alignItems: "center",
      width: "100%",
      fontSize: rem(32),
    },
  },
}));

export function HeaderNav() {
  const [drawerOpened, { toggle: toggleDrawer, close: closeDrawer }] =
    useDisclosure(false);
  const { classes, theme } = useStyles();

  return (
    <Box className="noselect">
      <Header
        className={classes.header}
        sx={{ borderBottom: 0 }}
        height={100}
        px="md"
      >
        <Group position="center" sx={{ height: "100%" }}>
          <Text fw={500}>
            <a href="https://vidyagiri.com" className={classes.titlelink}>
              {"vidya giri / ixorem"}
            </a>
          </Text>
          {/* <Group
            sx={{ height: "100%" }}
            spacing={0}
            className={classes.hiddenMobile}
          >
            <a href="../releases" className={classes.link}>
              index
            </a>
            <a
              href="https://ixorastudio.square.site/s/shop"
              className={classes.link}
            >
              store
            </a>
            <a href="../about" className={classes.link}>
              about
            </a>
          </Group> */}
          {/* <Burger
            color="#9b9974"
            opened={drawerOpened}
            onClick={toggleDrawer}
            className={classes.hiddenDesktop}
          /> */}
        </Group>
      </Header>

      {/* <Drawer
        opened={drawerOpened}
        onClose={closeDrawer}
        size="100%"
        padding="md"
        zIndex={1000000}
      >
        <ScrollArea h={`calc(100vh - ${rem(60)})`} mx="-md">
          <Text size="xl">
            <a href="../" className={classes.titlelink}>
              vidya giri
            </a>
          </Text>
          <Divider
            my="sm"
            color={theme.colorScheme === "dark" ? "dark.5" : "gray.1"}
          />
          <Text size="sm">
            <a href="../releases" className={classes.link}>
              index
            </a>
          </Text>
          <Text size="sm">
            <a
              href="https://ixorastudio.square.site/s/shop"
              className={classes.link}
            >
              store
            </a>
          </Text>
          <Text size="sm">
            <a href="../about" className={classes.link}>
              about
            </a>
          </Text>
          <Divider
            my="sm"
            color={theme.colorScheme === "dark" ? "dark.5" : "gray.1"}
          />
        </ScrollArea>
      </Drawer> */}
    </Box>
  );
}
